var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('Navbar',{style:(_vm.cssProps)}),_c('v-main',{staticStyle:{"margin-top":"-18px"},style:(_vm.cssProps)},[_c('transition',{attrs:{"name":"router-anim"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }